import { getApiClient } from '@apps/web/lib/api_client';
import { useApiQuery } from '@apps/web/swr_data_fetching/use_api_query';

export function useActivityEventAssignees(
    organizationId: string | null,
    organizationIds: ReadonlyArray<string>,
) {
    return useApiQuery({
        path: '/organizations/{organization_id}/activity-events/assignees',
        method: 'get',
        pathParams: organizationId
            ? { organization_id: organizationId }
            : undefined,
        queryParams:
            organizationIds.length > 0
                ? { organization_filter_id: [...organizationIds] }
                : {},
        enabled: !!organizationId,
        select: (response) => response,
        reason: 'activity-event-assignees',
    });
}

export async function updateActivityEventAssignments(
    organizationId: string,
    eventIds: ReadonlyArray<string>,
    assignedToUserIds: ReadonlyArray<string>,
) {
    return getApiClient().patch({
        url: '/organizations/{organization_id}/activity-events/assignments',
        pathParams: { organization_id: organizationId },
        body: {
            event_ids: [...eventIds],
            assigned_to_user_ids: [...assignedToUserIds],
        },
        reason: 'activity-event-update-assignments',
    });
}
